export default "__VITE_ASSET__Djd$45q0__"